import { cn } from '@/utils/cn'
import { Portfolio } from '../domain/entities/OrdersEntity'

export const PortfolioDetail = ({ portfolio, className }: { portfolio: Portfolio, className?: string }) => {
    return (
        <div
            className={cn(
                "text-card-foreground rounded-lg border border-primary-300 shadow-sm",
                "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 p-4",
                "dark:border-[--primary-700] dark:bg-[--primary-900]",
                "bg-primary-200",
                className,
            )}
        >
            <div className="space-y-1">
                <h4 className="text-sm leading-none text-sm font-medium">NIT/RUT</h4>
                <p className="text-muted-foreground text-xs">
                    {portfolio.nit}
                </p>
            </div>
            <div className="space-y-1">
                <h4 className="text-sm leading-none text-sm font-medium">DV</h4>
                <p className="text-muted-foreground text-xs">
                    {portfolio.dv}
                </p>
            </div>
            <div className="space-y-1">
                <h4 className="text-sm leading-none text-sm font-medium">CUENTA DECEVAL</h4>
                <p className="text-muted-foreground text-xs">
                    {portfolio.decevalAccount}
                </p>
            </div>
            <div className="space-y-1">
                <h4 className="text-sm leading-none text-sm font-medium">CUENTA DCV</h4>
                <p className="text-muted-foreground text-xs">
                    {portfolio.DCVAccount}
                </p>
            </div>
        </div>
    )
}
